import React, { Suspense } from "react";
// import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthProvider";
import { LoggerProvider } from "./context/LoggerProvider";
import "./index.css";
import "flag-icon-css/css/flag-icons.min.css";
import App from "./App";
import { Toaster } from "./components/ui/sonner";
import { PageLoader } from "./components/ui/page-loader";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initErrorLogger } from './utils/errorLogger';

// Initialize global error logging
initErrorLogger();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "cookie", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
    interpolation: {
      // React escapes rendered strings itself; i18next's default escaping
      // double-escapes interpolated values ("Health &amp; Energy").
      escapeValue: false,
    },
  });

// const { t } = useTranslation();

// const suspenseMarkup = <span>{t("loading")}</span>;
const suspenseMarkup = (
    <PageLoader fullScreen />
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={suspenseMarkup}>
    <LoggerProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </LoggerProvider>
    <Toaster expand={true} dir={i18n.dir} />
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
